import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { findDOMNode } from 'react-dom';
import { Button } from 'legacy/components/Button';
import isEmpty from 'lodash/isEmpty';

import TextArea from 'legacy/components/generic/TextArea';

import {
  Common as commonTheme,
  PropertyExplorerComments as theme
} from 'legacy/css-modules';

export default class PropertyExplorerComments extends Component {
  static propTypes = {
    commentValue: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    hasLoaded: PropTypes.bool.isRequired
  };
  state = {
    value: '',
    initialValue: ''
  };

  handleChange = (e) => {
    this.setState({ value: e.target.value });
  };

  handleSave = () => {
    if (this.state.value !== this.state.initialValue) {
      this.props.handleSave(this.state.value);
    }
    this.setState({ isEditing: false });
  };

  startEdit = () => {
    this.setState({ isEditing: true, initialValue: this.state.value });
    window.setTimeout(() => {
      if (this.inputElement) {
        this.inputElement.focus();
      }
    }, 0);
  };

  cancelEdit = () => {
    this.setState({
      isEditing: false,
      value: this.state.initialValue
    });
  };

  recordInputElement = (ele) => {
    if (ele) {
      this.inputElement = findDOMNode(ele).querySelector('textarea');
    }
  };

  componentDidUpdate(prevProps) {
    let updatedState = {};
    if (prevProps.commentValue !== this.props.commentValue) {
      updatedState.value = this.props.commentValue;
      updatedState.initialValue = this.props.commentValue;
      if (!this.state.value) {
        updatedState.isEditing = false;
      }
    }
    if (
      !this.props.commentValue &&
      ((prevProps.readOnly && !this.props.readOnly) ||
        (!prevProps.hasLoaded && this.props.hasLoaded))
    ) {
      updatedState.isEditing = true;
    }
    if (!isEmpty(updatedState)) {
      this.setState(updatedState);
    }
  }

  componentDidMount() {
    this.setState({
      value: this.props.commentValue,
      initialValue: this.props.commentValue,
      isEditing: !this.props.commentValue && this.props.hasLoaded
    });
    // Ensure we're not in editing mode when printing, saving if necessary
    window.matchMedia('print').addListener(this.handleSave);
  }

  componentWillUnmount() {
    window.matchMedia('print').removeListener(this.handleSave);
  }

  render() {
    const { readOnly, hasLoaded } = this.props;
    const { isEditing, value, initialValue } = this.state;
    return (
      hasLoaded &&
      !(readOnly && !value) && (
        <div
          data-hc-name="comments-section"
          className={theme.CommentBoxContainer}
        >
          {isEditing && !readOnly ? (
            <TextArea
              maxLength={2550}
              input={{
                style: { resize: 'vertical' },
                placeholder: 'Type your comments here',
                value: value
              }}
              onChange={this.handleChange}
              dataHcNames={{
                textarea: 'comments-text-area',
                charCount: 'comments-text-area-char-count'
              }}
              ref={this.recordInputElement}
            />
          ) : (
            <div
              className={classNames(
                theme['comments-value'],
                commonTheme['small-text']
              )}
              data-hc-name="comments-saved"
              onClick={this.startEdit}
            >
              {value || (
                <span className={commonTheme['placeholder-text']}>
                  No comments
                </span>
              )}
            </div>
          )}
          <div
            data-hc-name="comments-header-text"
            className={theme.SaveButtonContainer}
          >
            <Button
              key="save"
              data-hc-name="comments-save-button"
              disabled={readOnly || value === initialValue}
              onClick={this.handleSave}
            >
              Save
            </Button>
          </div>
        </div>
      )
    );
  }
}
